import { request } from './client.js';

export async function getCart() {
  const data = await request('/api/cart', { method: 'GET' });
  return data.items || [];
}

export async function addToCart(payload) {
  // Can be { name: '...' }, { names: [...] }, or { items: [...] }
  let body = {};
  if (typeof payload === 'string') {
    body = { name: payload };
  } else if (Array.isArray(payload)) {
    if (typeof payload[0] === 'string') {
      body = { names: payload };
    } else {
      body = { items: payload };
    }
  } else {
    body = payload;
  }

  return await request('/api/cart', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateCartItem(id, updates) {
  return await request(`/api/cart/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

export async function batchUpdateCart(updates) {
  return await request('/api/cart/batch', {
    method: 'PATCH',
    body: JSON.stringify({ updates }),
  });
}

export async function deleteCartItem(id) {
  return await request(`/api/cart/${id}`, {
    method: 'DELETE',
  });
}

export async function clearCompletedCart() {
  return await request('/api/cart/completed', {
    method: 'DELETE',
  });
}

export async function clearAllCart() {
  return await request('/api/cart/all', {
    method: 'DELETE',
  });
}
